import React, { Component } from 'react';
import brandLogo from '../images/brand-logo-inverse-dark.png';
import { translate } from 'react-i18next';
import { LANG } from '../App.js';
import { Link } from 'react-router-dom';
import Input from '../components/Input/index.jsx';
import Header from '../components/Header/index.jsx';

class Login extends Component {

  constructor(props) {
    super(props);

    window.fbLoaded.promise.then(() => {

      window.FB.XFBML.parse();
      // var spinner = document.getElementById("facebookSpinner");
      // spinner.removeAttribute("class");
      // spinner.removeChild(spinner.childNodes[0]);
    });

    window.googleLoaded.promise.then(() => {
      this.initializeGoogle();
    });
  }


  initializeGoogle = () => {
    this.props.loadGoogle("LOGIN");
  }

  render() {
    const { t } = this.props;
    return (
      <div className="panel">
        <div className="panel-content">
          {/* <div className="panel-heading-signup text-center">
            <img height="64px" alt="IOS OFFICES" src={brandLogo} />
          </div> */}
          <div className="panel-body-singup">
            <Header
              site='iosfera' 
              handleLanguageChange={this.props.handleLanguageChange}
            />
            <h4 className='center'>{t('onboarding.login.heading')}</h4>
            <form method="post" onSubmit={this.props.handleLoginSubmit}>
              <fieldset>
                <div className="form-group">
                  <Input className="form-control"
                    onChange={this.props.handleEmailChange}
                    placeholder={t('onboarding.login.holder_email')}
                    required
                    type="email"
                    autoFocus
                    value={this.props.email} />
                </div>
                <div className="form-group">
                  <Input
                    className="form-control"
                    onChange={this.props.handlePasswordChange}
                    placeholder={t('onboarding.login.holder_password')}
                    required
                    type="password"
                    value={this.props.password} />
                </div>
                <p className="">
                  <button
                    className="btn-link btn_password"
                    disabled={!this.props.email}
                    onClick={this.props.handlePasswordReset}
                    type="button">
                    {t('onboarding.login.password')}
                  </button>
                </p>
                <div className={this.props.success ? "" : "hidden"}>
                  <div className="alert alert-success">
                    <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearSuccess} />
                    {this.props.success}
                  </div>
                </div>
                <div className={this.props.error ? "" : "hidden"}>
                  <div className="alert alert-warning">
                    {this.props.error}
                    <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                  </div>
                </div>
                <div className="form-group">
                  <button
                    className="btn btn-block btn-primary"
                    type="submit"
                    disabled={this.props.isLoading}
                  >
                    {t('onboarding.login.btn_login')}
                  </button>
                </div>
                {/* <div className="form-group full">                      
                  <div id="gSignInWrapper">
                    <div id="customBtn" className="customGPlusSignIn">
                      <span className="icon"></span>
                      <span className="buttonText">{t('onboarding.login.google')}</span>
                    </div>
                  </div>
              </div>
              <div className="form-group"> 
               <div>
                <div id="facebookSpinner" className="facebookSpinner">
                        <span>Loading</span>
                        <a href="" className="fb connect" onClick={this.props.loginWithFacebook}>{t('onboarding.login.facebook')}</a>
                </div> 
                </div>
              </div> */}
              </fieldset>
            </form>
            <p className="small signup">{t('onboarding.login.signup')}
            <button
              className="btn btn-link btn_password"
              onClick={this.props.handleSignupClick}
              type="button">
                {t('onboarding.login.btn_signup')}
            </button>
            </p>
            {/* <div className="desktop_container movil_container">
              <div className="form-group">
                <button
                  className="btn btn-block btn-primary  btn-singup btn_create"
                  onClick={this.props.handleSignupClick}
                  type="button">
                  {t('onboarding.login.btn_signup')}
                </button>
              </div> */}
            <div className="mobile-container">
                <div className="form-group">
                  <button type="button" className="btn btn-secondary btn-full-width" data-toggle="modal" data-target=".bs-example-modal-lg-singup">
                    {t('onboarding.login.other')}
                  </button>
                </div>
              </div>
              <div className="form-group">
                <Link to="/store">
                  <button className="btn btn-secondary btn-full-width">
                    {t('onboarding.booking.btn_book')}
                    <i className="glyphicon glyphicon-arrow-right" style={{ marginLeft: "10px" }} />
                  </button>
                </Link>
              </div>
            {/* </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(Login);



// WEBPACK FOOTER //
// ./src/onboarding/Login.js